"use client";

import { Info } from "lucide-react";
import { cn } from "../../lib/utils";

export interface StatItem {
  value: string;
  label: string;
  tooltip?: string;
  className?: string;
  valueClassName?: string;
  labelClassName?: string;
}

export interface StatsRowProps extends React.HTMLAttributes<HTMLDivElement> {
  stats: StatItem[];
}

export function StatsRow({ stats, className, ...props }: StatsRowProps) {
  return (
    <div
      className={cn(
        "flex items-center w-full justify-between gap-2",
        className,
      )}
      {...props}
    >
      {stats.map((stat, index) => (
        <div
          key={index}
          className={cn(
            "flex-1 basis-0 rounded-lg border border-black bg-white shadow-[0px_4px_0px_0px_#000000] px-3 py-3 flex flex-col items-center justify-center gap-1.5",
            stat.className
          )}
        >
          <p className={cn(
            "text-[24px] font-medium leading-none",
            stat.valueClassName || "text-[#ED5AA9]"
          )}>
            {stat.value}
          </p>
          <div className="group relative flex items-center gap-1">
            <p className={cn(
              "text-[12px] leading-5 line-clamp-1",
              stat.labelClassName || "text-[#475467]"
            )}>
              {stat.label}
            </p>
            {stat.tooltip && (
              <>
                <Info className={cn("size-3 cursor-help", stat.labelClassName || "text-[#98A2B3]")} />
                <div className="absolute bottom-full left-1/2 z-20 mb-2 hidden w-32 -translate-x-1/2 rounded-md bg-[#101828] p-2 text-center text-[10px] text-white shadow-lg group-hover:block">
                  {stat.tooltip}
                  <div className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-[#101828]" />
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
